import * as z from "zod";
export const Divider = z.object({
    type: z.literal("divider"),
    value: z.object({}).optional(),
});
